var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body" }, [
      _c(
        "div",
        { staticClass: "report-content", staticStyle: { width: "100%" } },
        [
          _vm.loading
            ? _c("span", { staticClass: "error loading status_padding" }, [
                _c("i", {
                  staticClass: "fa fa-spinner fa-pulse",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v("Загрузка\n        данных...\n      "),
              ])
            : _vm.error
            ? _c("span", { staticClass: "error status_padding" }, [
                _c("i", {
                  staticClass: "fa fa-exclamation-triangle",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v("Ошибка\n        загрузки данных\n      "),
              ])
            : _vm.isStatsEmpty
            ? _c("span", [
                _c("p", { staticClass: "error no-data-message" }, [
                  _vm._v("Нет данных для статистики"),
                ]),
              ])
            : _c("GChart", {
                attrs: {
                  type: "PieChart",
                  data: _vm.chartData,
                  options: _vm.chartOptions,
                },
              }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title text-center" }, [
        _vm._v("\n      Прогресс обучения\n      "),
        _c("i", {
          staticClass: "icon md-help-outline cursor-pointer",
          attrs: {
            "aria-hidden": "true",
            "data-toggle": "popover",
            "data-html": "true",
            "data-trigger": "click | hover",
            "data-content": "Высчитывается из количества сданных экзаменов",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }